import "./product-top.scss";
import { HelpHeader } from "../../../organisms/help/header/header";
import {
  useHelpProductTopController,
  useHelpProductTopHomeController,
} from "./use-product-top-controller";
import {
  BeginnerGuideContent,
  ProductInformationContent,
  ReleaseNoteContent,
  SearchFunctionContent,
  TrainingContent,
} from "../../../organisms/help/category/category";
import { SearchResults } from "../../../organisms/help/search-results/search-results";
import { HelpTemplate } from "../../../template/help/default-template";
import { Spinner } from "@graffer-inc/console-design-kit";

const Home: React.FC<{
  productId: string | undefined;
}> = ({ productId }) => {
  const {
    categoryListResult: { categoryList, isLoading },
  } = useHelpProductTopHomeController(productId);
  return (
    <>
      {isLoading ? (
        <Spinner loading={isLoading} />
      ) : (
        <div className="help-top-container">
          <a
            href="/help"
            className="help-return-top-link"
          >{`< トップページに戻る`}</a>
          <div className="help-content-box">
            <BeginnerGuideContent
              columnsNumber={1}
              categoryList={categoryList}
            />
            <TrainingContent columnsNumber={1} categoryList={categoryList} />
            <SearchFunctionContent
              columnsNumber={1}
              categoryList={categoryList}
            />
            <ReleaseNoteContent columnsNumber={1} categoryList={categoryList} />
            <ProductInformationContent
              columnsNumber={1}
              categoryList={categoryList}
            />
          </div>
        </div>
      )}
    </>
  );
};

export const HelpProductTop = () => {
  const {
    title,
    subtitle,
    query,
    condition,
    result,
    productId,
    tags,
    isLoading,
    onChangeSearchCondition,
    onChangeSearchText,
    onChangeTags,
    onChangeProduct,
  } = useHelpProductTopController();

  return (
    <HelpTemplate>
      <HelpHeader
        title={title}
        subtitle={subtitle}
        condition={condition}
        query={query}
        onChangeSearchCondition={onChangeSearchCondition}
        onChangeSearchText={onChangeSearchText}
      />
      {query.length > 0 ? (
        <SearchResults
          query={query}
          contentsList={result ?? []}
          onChangeProduct={onChangeProduct}
          onChangeTags={onChangeTags}
          selectedTags={tags}
          selectedProductId={productId}
          isLoading={isLoading}
        />
      ) : (
        <Home productId={productId} />
      )}
    </HelpTemplate>
  );
};
